'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import { ChildImageVariantEnum } from '@sola/ark-core/utils/child-image.ts';
import { getChildBioPath, knownMyUrls } from '@sola/my-sdk/constants.ts';
import { BackButton } from '../../atoms/back-button/back-button.tsx';
import { ChildSpotlightCard, ChildSpotlightImage } from '../child-spotlight-card/child-spotlight-card.tsx';
import { useDepartureSpotlightCard } from './departure-spotlight-card.logic.tsx';
export const DepartureSpotlightCard = () => {
  const $ = _c(45);
  const {
    t,
    hasGlobalId,
    hasMultipleSponsorships,
    isLoading,
    hasError,
    cardData
  } = useDepartureSpotlightCard();
  if (!hasGlobalId) {
    return null;
  }
  if (isLoading) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="DeparturePage__card flex w-full flex-col gap-comfy-xl"><Skeleton height={24} width={180} /><Skeleton height={540} width="100%" borderRadius="1rem" /></div>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (hasError || !cardData) {
    let t0;
    if ($[1] !== t) {
      t0 = t("my:sponsorshipRelationship.childBio.alert.title");
      $[1] = t;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    let t1;
    if ($[3] !== t) {
      t1 = t("my:sponsorshipRelationship.childBio.alert.message");
      $[3] = t;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
      t2 = <Alert variant="negative" title={t0} message={t1} />;
      $[5] = t0;
      $[6] = t1;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  let t0;
  if ($[8] !== cardData.childName || $[9] !== hasMultipleSponsorships || $[10] !== t) {
    t0 = hasMultipleSponsorships ? t("my:sponsorshipRelationship.childBio.backButton.text") : t("my:sponsorshipRelationship.childBio.detailsTitle", {
      childName: cardData.childName
    });
    $[8] = cardData.childName;
    $[9] = hasMultipleSponsorships;
    $[10] = t;
    $[11] = t0;
  } else {
    t0 = $[11];
  }
  const backButtonLabel = t0;
  let t1;
  if ($[12] !== cardData.childGlobalId || $[13] !== hasMultipleSponsorships) {
    t1 = hasMultipleSponsorships ? knownMyUrls.sponsorshipsBase : getChildBioPath(cardData.childGlobalId);
    $[12] = cardData.childGlobalId;
    $[13] = hasMultipleSponsorships;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  const backButtonUrl = t1;
  const hasSponsorYears = cardData.sponsorYears !== undefined;
  let t2;
  if ($[15] !== backButtonLabel || $[16] !== backButtonUrl) {
    t2 = <BackButton url={backButtonUrl} label={backButtonLabel} />;
    $[15] = backButtonLabel;
    $[16] = backButtonUrl;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[18] !== cardData.childImageUrl || $[19] !== cardData.childName) {
    t3 = <ChildSpotlightImage childImageUrl={cardData.childImageUrl} alt={cardData.childName} variantMd={ChildImageVariantEnum.Full} />;
    $[18] = cardData.childImageUrl;
    $[19] = cardData.childName;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  let t4;
  if ($[21] !== cardData.childName || $[22] !== cardData.titleKey || $[23] !== t) {
    t4 = t(cardData.titleKey, {
      childName: cardData.childName
    });
    $[21] = cardData.childName;
    $[22] = cardData.titleKey;
    $[23] = t;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  let t5;
  if ($[25] !== t4) {
    t5 = <h2 className="ChildSpotlightCard__title m-none w-full heading-neutral-amplified heading-sm md:heading-md">{t4}</h2>;
    $[25] = t4;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  const t6 = hasSponsorYears ? "my:sponsorshipRelationship.departures.spotlight.departure.descriptionIntro" : "my:sponsorshipRelationship.departures.spotlight.departure.descriptionIntroFallback";
  let t7;
  if ($[27] !== cardData.childName || $[28] !== cardData.gender || $[29] !== cardData.sponsorYears || $[30] !== hasSponsorYears || $[31] !== t || $[32] !== t6) {
    t7 = t(t6, {
      childName: cardData.childName,
      ...(hasSponsorYears ? {
        context: cardData.gender ?? undefined,
        sponsorYears: cardData.sponsorYears
      } : {})
    });
    $[27] = cardData.childName;
    $[28] = cardData.gender;
    $[29] = cardData.sponsorYears;
    $[30] = hasSponsorYears;
    $[31] = t;
    $[32] = t6;
    $[33] = t7;
  } else {
    t7 = $[33];
  }
  let t8;
  if ($[34] !== t7) {
    t8 = <div className="ChildSpotlightCard__description w-full body-neutral-mild body-sm md:body-md"><p>{t7}</p></div>;
    $[34] = t7;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  let t9;
  if ($[36] !== t5 || $[37] !== t8) {
    t9 = <div className="flex h-full flex-col justify-center gap-comfy-lg md:p-roomy-xs"><div className="ChildSpotlightCard__text flex w-full flex-col gap-comfy-xs">{t5}{t8}</div></div>;
    $[36] = t5;
    $[37] = t8;
    $[38] = t9;
  } else {
    t9 = $[38];
  }
  let t10;
  if ($[39] !== t3 || $[40] !== t9) {
    t10 = <ChildSpotlightCard image={t3}>{t9}</ChildSpotlightCard>;
    $[39] = t3;
    $[40] = t9;
    $[41] = t10;
  } else {
    t10 = $[41];
  }
  let t11;
  if ($[42] !== t10 || $[43] !== t2) {
    t11 = <div className="flex w-full flex-col gap-comfy-lg">{t2}{t10}</div>;
    $[42] = t10;
    $[43] = t2;
    $[44] = t11;
  } else {
    t11 = $[44];
  }
  return t11;
};